module.exports = __webpack_public_path__ + "media/images/icons/big-arrow-up-6a59b4875f4bd06ee0136264c4f1f065.svg";